export default __webpack_public_path__ + "static/media/CNo.70-1.bd1ca632.jpg";